import React from 'react';
import { Menu, MenuItem, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ActionsMenuProps {
    anchorElActionsMenu: HTMLElement | null;
    handleCloseActionsMenu: () => void;
    handleMarkSelectedAsRead: () => void;
    handleMarkSelectedAsUnread: () => void;
    handleDeleteSelected: () => void;
}

const ActionsMenu = ({
    anchorElActionsMenu,
    handleCloseActionsMenu,
    handleMarkSelectedAsRead,
    handleMarkSelectedAsUnread,
    handleDeleteSelected,
}:ActionsMenuProps) => {

    const [t] = useTranslation("global");


    
    return (
        <Menu
            id="actions-menu"
            anchorEl={anchorElActionsMenu}
            keepMounted
            open={Boolean(anchorElActionsMenu)}
            onClose={handleCloseActionsMenu}
        >
            <MenuItem onClick={handleMarkSelectedAsRead}>{t("generic.notifications.actions.mark-as-read")}</MenuItem>
            <MenuItem onClick={handleMarkSelectedAsUnread}>{t("generic.notifications.actions.mark-as-unread")}</MenuItem>
            <MenuItem onClick={handleDeleteSelected}>{t("generic.notifications.actions.mark-as-deleted")}</MenuItem>
        </Menu>
    );
};

export default ActionsMenu;